import { useQuoteModal } from '../../../../context/QuoteModalContext';
import { Link } from 'react-router-dom';

const colours = [
  // Neutrals
  { name: 'White',        hex: '#FFFFFF', border: true },
  { name: 'Grey',         hex: '#9E9E9E', border: false },
  { name: 'Charcoal',     hex: '#36454F', border: false },
  { name: 'Taupe',        hex: '#A89080', border: false },
  { name: 'Tan',          hex: '#C49A5A', border: false },
  // Greens
  { name: 'Lime',         hex: '#C6E832', border: false },
  { name: 'Sage',         hex: '#A8B87A', border: false },
  { name: 'Green',        hex: '#2ECC40', border: false },
  { name: 'Bottle Green', hex: '#1B5E3B', border: false },
  // Blues
  { name: 'Turquoise',    hex: '#00D4D4', border: false },
  { name: 'Blue',         hex: '#1A44CC', border: false },
  // Yellows
  { name: 'Yellow',       hex: '#F5D000', border: false },
  // Oranges
  { name: 'Orange',       hex: '#F47B20', border: false },
  // Reds
  { name: 'Red',          hex: '#E8192C', border: false },
  { name: 'Burgundy',     hex: '#800020', border: false },
  // Pinks
  { name: 'Pink',         hex: '#FF2D9B', border: false },
];

export default function ColourSwatches() {
  const { openModal } = useQuoteModal();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">

        {/* Teal Divider */}
        <div className="flex items-center gap-6 mb-16">
          <div className="flex-1 h-px bg-teal-400"></div>
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 whitespace-nowrap">
            Available Colors
          </h2>
          <div className="flex-1 h-px bg-teal-400"></div>
        </div>

        {/* Color Intro */}
        <p className="text-center text-lg text-gray-600 max-w-2xl mx-auto mb-14">
          Our stretch tents are available in a wide range of colors to suit any event theme, brand palette, or venue aesthetic.
        </p>

        {/* Color Swatches Grid */}
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-5 mb-14">
          {colours.map((colour) => (
            <div key={colour.name} className="flex flex-col items-center gap-2 group cursor-default">
              <div
                className={`w-full aspect-square rounded-xl transition-transform duration-300 group-hover:scale-105 ${
                  colour.border ? 'border-2 border-gray-200' : ''
                }`}
                style={{ backgroundColor: colour.hex }}
              ></div>
              <span className="text-xs font-medium text-gray-600 text-center leading-tight">
                {colour.name}
              </span>
            </div>
          ))}
        </div>

        {/* Custom Color Callout */}
        <div className="bg-teal-50 border border-teal-200 rounded-xl p-8 flex flex-col md:flex-row items-start md:items-center gap-5">
          <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl flex-shrink-0">
            <i className="ri-palette-line text-2xl text-teal-600"></i>
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-bold text-gray-900 mb-1">
              Don&apos;t see your color?
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              We offer custom color matching for custom printed skins. Contact us to discuss your requirements and we&apos;ll find the perfect match for your brand or event.
            </p>
          </div>
          <div className="flex gap-3 flex-shrink-0">
            <Link
              to="/products/custom-printed-skins"
              className="inline-block border border-teal-400 text-teal-600 hover:bg-teal-50 px-5 py-2.5 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Custom Skins
            </Link>
            <button
              type="button"
              onClick={openModal}
              className="inline-block bg-teal-400 hover:bg-teal-500 text-white px-5 py-2.5 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
